// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"897b53d3","455":"9bdb568a"}[chunkId] + ".chunk.js";
};